import clsx from "clsx";

type SessionTagPillProps = {
  tag: string;
  onClick?: (tag: string) => void;
};

// Single color scheme for all tags
const tagColors = {
  bg: "bg-cyan-100 dark:bg-cyan-900/30",
  text: "text-cyan-700 dark:text-cyan-300",
  keyText: "text-cyan-600 dark:text-cyan-400",
};

export const SessionTagPill = ({ tag, onClick }: SessionTagPillProps) => {
  // Parse key:value format
  const colonIndex = tag.indexOf(":");
  const hasKeyValue = colonIndex > 0;
  const tagKey = hasKeyValue ? tag.slice(0, colonIndex) : null;
  const tagValue = hasKeyValue ? tag.slice(colonIndex + 1) : tag;

  // Format the value for display (replace hyphens with spaces, truncate if needed)
  const displayValue = tagValue.replace(/-/g, " ").slice(0, 20) + (tagValue.length > 20 ? "..." : "");

  return (
    <span
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick(tag);
            }
          : undefined
      }
      title={tag}
      className={clsx("w-auto px-1.5 py-0.5 rounded text-xs flex flex-row items-center gap-1", tagColors.bg, onClick && "cursor-pointer hover:opacity-80")}
    >
      {tagKey && <span className={clsx("font-medium", tagColors.keyText)}>{tagKey}</span>}
      <span className={tagColors.text}>{displayValue}</span>
    </span>
  );
};
